import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { PurchaseAttempt } from './purchase-attempt.model';
import { PurchaseAttemptTransformer } from './purchase-attempt.transformer';

import { ApiPurchaseAttemptService } from '@api/_api/api-purchase-attempt/api-purchase-attempt.service';

@Injectable()
export class PurchaseAttemptService {
    constructor(
        private readonly apiPurchaseAttemptService: ApiPurchaseAttemptService,
    ) {}

    public getPurchaseAttempt(storeId: string, orderId: string, languageId: string) {
        return this.apiPurchaseAttemptService.purchaseAttempt(storeId, orderId, languageId).pipe(
            map(
                (apiPurchaseAttempt): PurchaseAttempt => {
                    return PurchaseAttemptTransformer.PurchaseAttemptFromApi(apiPurchaseAttempt);
                }
            )
        );
    }

    public getOrderPreview(storeId: string, languageId: string) {
        return this.apiPurchaseAttemptService.orderPreview(storeId, languageId);
    }

    public getBuyNowOrderPreview(storeId: string, languageId: string, buyNowCartId: number) {
        return this.apiPurchaseAttemptService.buyNowOrderPreview(storeId, languageId, buyNowCartId);
    }
}
